<template>
  <div class="flex-container">
    <div class="label" v-if="check">
      <p>{{ label }}</p>
      <br v-if="brCheck && !isCheckSizeSmall" />
      <router-link v-else-if="isRouterLink && !icon && isCheckSizeSmall" :to="to" class="routerLink">
        <span>{{ value }}</span>
      </router-link>
    </div>
    <div class="border-left"></div>
    <div class="content" v-if="check">
      <span v-if="!isRouterLink && !icon" class="info-details">{{ value }}</span>
      <router-link v-else-if="isRouterLink && !icon && !isCheckSizeSmall" :to="to" class="routerLink">
        <span class="info-details">{{ value }}</span>
      </router-link>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="info-details"
            color="#ffffff"
            v-bind="attrs"
            v-on="on"
          >
            {{ icon }}
          </v-icon>
        </template>
        <span>В разработке...</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: null,
      required: true,
    },
    icon: {
      type: null,
    },
    check: {
      type: null,
      required: true,
    },
    brCheck: {
      type: Boolean,
      default: false,
    },
    isCheckSizeSmall: {
      type: Boolean,
    },
    isRouterLink: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.routerLink {
  text-decoration: none;
  color: #08eae0;
}
a:hover.routerLink {
  text-decoration: underline;
}
.flex-container {
  display: flex;
}

.label {
  flex: 0 0 60%;
}

.border-left {
  border-left: 1px solid #ffffff;
}

.content {
  padding-left: 5px;
  display: block;
  word-wrap: break-word;
}

.info-details {
  font-weight: 400 !important;
  padding-left: 15px;
  font-size: 17px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;

  max-width: 100%;
  display: inline-block;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
.v-application p {
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 16px;
  font-family: 'Montserrat', sans-serif;
}
@media screen and (max-width: 1590px) {
  .label {
    flex: 0 0 70%;
  }
}
@media screen and (max-width: 800px) {
  .label {
    flex: 0 0 80%;
  }
  .info-details {
    font-size: 16px;
  }
  .content {
    padding-top: 5px;
  }
  .v-application p {
    font-size: 14px;
    padding-top: 5px;
  }
}
</style>
